module.exports = __webpack_public_path__ + "static/img/puji22.c8e3fa73.png";